export enum EnumWorkflowMode {
  All = "all",
  My = "my",
}
